import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { CustomNavigationClient } from '../../shared/msal';
import { RoutePaths } from '../../route-paths';
import { Spinner } from '@fluentui/react-components';

export const ResponseOidcPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const customNavigationClient = new CustomNavigationClient(navigate);
    broadcastResponseToMainFrame(customNavigationClient).catch((error) => {
      console.error('Error broadcasting response to main frame:', error);
      navigate(RoutePaths.Home, { replace: true });
    });
  }, [navigate]);

  return (
    <div>
      <Spinner 
        label='Authenticating...'
        size='huge'
      />
    </div>
  );
};